<template>
    <div class="layout-cards grid grid-cols-1 gap-8 lg:grid-cols-2">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LayoutColumns',
};
</script>
